import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Eye, CheckCircle2, XCircle } from "lucide-react";

export default function SignupVisibilityCheck() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [onlyHidden, setOnlyHidden] = useState(true);

  const run = async () => {
    try {
      const { data } = await api.get("/admin/roster/signup-visibility");
      setData(data); setOpen(true);
    } catch { toast.error("Could not run check"); }
  };

  const rows = (data?.rows || []).filter((r) => !onlyHidden || !r.visible_in_signup);
  return (
    <>
      <Button variant="outline" onClick={run} title="See which roster names students can find on the Register page" data-testid="roster-signup-check-btn">
        <Eye className="w-4 h-4 mr-1.5" /> Check sign-up list
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-none max-w-3xl max-h-[85vh] flex flex-col" data-testid="roster-signup-check-dialog">
          <DialogHeader><DialogTitle className="font-display tracking-tight">Who can find their name on the Register page?</DialogTitle></DialogHeader>
          {data && (
            <>
              <div className="text-sm text-[#525252]" data-testid="roster-signup-check-summary">
                <strong className="text-[#0F1F2E]">{data.visible}</strong> of <strong className="text-[#0F1F2E]">{data.total}</strong> roster names are visible to students signing up.
                Hidden names are either already registered (expected) or withdrawn.
              </div>
              <label className="text-xs inline-flex items-center gap-2 cursor-pointer"><input type="checkbox" checked={onlyHidden} onChange={(e) => setOnlyHidden(e.target.checked)} data-testid="roster-signup-check-only-hidden" /> Show only hidden names</label>
              <div className="overflow-y-auto flex-1 border border-[#E5E7EB]">
                <table className="w-full text-sm">
                  <thead className="bg-[#F3F4F6] text-[10px] uppercase tracking-[0.16em] text-[#525252]"><tr><th className="text-left px-3 py-2">Name</th><th className="text-left px-3 py-2">Team</th><th className="text-left px-3 py-2">In sign-up list?</th><th className="text-left px-3 py-2">Why / matched account</th></tr></thead>
                  <tbody className="divide-y divide-[#E5E7EB]">
                    {rows.map((r) => (
                      <tr key={r.id} data-testid={`roster-signup-check-row-${r.id}`}>
                        <td className="px-3 py-2"><div className="font-medium">{r.name || <em className="text-[#A23232]">no name</em>}</div><div className="text-[11px] text-[#525252]">{r.email}</div></td>
                        <td className="px-3 py-2 text-[#525252]">{r.team_letter || "—"}</td>
                        <td className="px-3 py-2">{r.visible_in_signup ? <span className="inline-flex items-center gap-1 text-[#0F5A5A]"><CheckCircle2 size={14} /> Yes</span> : <span className="inline-flex items-center gap-1 text-[#A23232]"><XCircle size={14} /> Hidden</span>}</td>
                        <td className="px-3 py-2 text-[#525252] text-xs">{r.reason || "—"}{r.matched_account && <div>{r.matched_account.name} · {r.matched_account.email}</div>}</td>
                      </tr>
                    ))}
                    {rows.length === 0 && <tr><td colSpan={4} className="px-3 py-6 text-center text-sm text-[#525252] italic">Every roster name is visible to students.</td></tr>}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
